export const GET_TRANSLATIONS = 'GET_TRANSLATIONS';

export const SHOW_GLOBAL_LOADER = 'SHOW_GLOBAL_LOADER';
export const HIDE_GLOBAL_LOADER = 'HIDE_GLOBAL_LOADER';

export const SHOW_GLOBAL_ERROR = 'SHOW_GLOBAL_ERROR';
export const CLEAR_GLOBAL_ERROR = 'CLEAR_GLOBAL_ERROR';

export const GET_LOCATIONS = 'GET_LOCATIONS';
export const GET_LOCATIONS_V2 = 'GET_LOCATIONS_V2';
export const GET_LOCATIONS_SUCCESS = 'GET_LOCATIONS_SUCCESS';
export const GET_LOCATIONS_FAILURE = 'GET_LOCATIONS_FAILURE';

export const GET_HOME_CHARGERS = 'GET_HOME_CHARGERS';
export const GET_HOME_CHARGERS_V2 = 'GET_HOME_CHARGERS_V2';
export const GET_HOME_CHARGERS_SUCCESS = 'GET_HOME_CHARGERS_SUCCESS';
export const GET_HOME_CHARGERS_FAILURE = 'GET_HOME_CHARGERS_FAILURE';
export const SET_HOME_CHARGERS_DISPLAY = 'SET_HOME_CHARGERS_DISPLAY';
export const CLEAR_HOME_CHARGERS = 'CLEAR_HOME_CHARGERS';

export const GET_3RD_PARTY_CHARGERS = 'GET_3RD_PARTY_CHARGERS';
export const GET_3RD_PARTY_CHARGERS_SUCCESS = 'GET_3RD_PARTY_CHARGERS_SUCCESS';
export const GET_3RD_PARTY_CHARGERS_FAILURE = 'GET_3RD_PARTY_CHARGERS_FAILURE';

export const GET_SELECTED_LOCATION_DETAIL = 'GET_SELECTED_LOCATION_DETAIL';
export const GET_SELECTED_LOCATION_DETAIL_SUCCESS = 'GET_SELECTED_LOCATION_DETAIL_SUCCESS';
export const GET_SELECTED_LOCATION_DETAIL_FAILURE = 'GET_SELECTED_LOCATION_DETAIL_FAILURE';
export const CLEAR_SELECTED_LOCATION_DETAIL = 'CLEAR_SELECTED_LOCATION_DETAIL';

export const GET_LOCATIONS_DETAIL = 'GET_LOCATIONS_DETAIL';
export const GET_LOCATIONS_DETAIL_SUCCESS = 'GET_LOCATIONS_DETAIL_SUCCESS';
export const GET_LOCATIONS_DETAIL_FAILURE = 'GET_LOCATIONS_DETAIL_FAILURE';

export const SET_MAP_MODE = 'SET_MAP_MODE';
export const SET_FILTER = 'SET_FILTER';
export const SET_CURRENT_LOCATION = 'SET_CURRENT_LOCATION';
